/*eslint no-undef: "off"*/
import { useQueryItemBase } from '@/composables/query/item/base/useQueryItemBase'

export function useQueryItem(
    name,
    defaultValue = null,
    { onChange = () => {}, transform = (val) => val, label = null } = {}
) {
    const query = ref(defaultValue)

    const { set, toPayload, setNull, toValue } = useQueryItemBase(name, query, {
        onChange,
        transform,
    })

    function reset() {
        query.value = defaultValue
        onChange()
    }

    return {
        set,
        query,
        toPayload,
        setNull,
        reset,
        toValue,
        key: name,
        label,
    }
}
